import axios from 'axios';
import authApi from './auth';

export const api = axios.create({
  baseURL: process.env.REACT_APP_PI_URL,
});

export const authenticatedApi = axios.create({
  baseURL: process.env.REACT_APP_PI_URL,
  headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` },
});

authenticatedApi.interceptors.response.use(
  (response) => {
    return response;
  },
  async function (error) {
    try {
      const originalRequest = error.config;
      if (error.response.status === 401 && error.response.data.error === 'Token expired') {
        originalRequest._retry = true;
        const refreshToken = localStorage.getItem('refreshToken');
        if (refreshToken) {
          const { data } = await authApi.refreshToken(refreshToken);
          await localStorage.setItem('accessToken', data.access_token);
          authenticatedApi.defaults.headers.common['Authorization'] = 'Bearer ' + data.access_token;
          originalRequest.headers.Authorization = 'Bearer ' + data.access_token;
          return authenticatedApi(originalRequest);
        } else {
          localStorage.removeItem('accessToken');
          localStorage.removeItem('refreshToken');
          localStorage.clear();
          window.location.reload();
        }
      }
      return Promise.reject(error);
    } catch (e) {
      localStorage.removeItem('accessToken');
      localStorage.removeItem('refreshToken');
      localStorage.clear();
      window.location.reload();
    }
  }
);
